import Swal from "sweetalert2";

const MySwal = Swal.mixin({
	customClass: {
		cancelButton: "btn btn-danger",
		confirmButton: "btn btn-success",
		title: "font-weight-bold text-left",
		footer: "swal-footer",
	},
	allowOutsideClick: false,
	buttonsStyling: false,
});

export const handleSubmit = async ({ changeLoading }) => {
	changeLoading(true);

	MySwal.fire({
		title: "Enviar solicitud",
		icon: "warning",
		text: "Los nuevos documentos serán enviados, para ser revisados por la AFP. Si necesitas revisarlos puedes volver atrás.",
		showCancelButton: true,
		confirmButtonText: "Confirmar",
		cancelButtonText: "Volver al paso anterior",
		customClass: {
			confirmButton: "btn btn-success",
			cancelButton: "btn btn-danger",
		},
		allowOutsideClick: false,
	}).then((result) => {
		changeLoading(false);
		if (result.isConfirmed) {
			window.location = "doc/comprobante";
		}
	});
};
